// TShirtHeroLoginPopup.tsx
import * as React from 'react';
import { connect } from 'react-redux';
import { CSSProperties } from 'react';
import { browserHistory } from 'react-router';
import Radium, { StyleRoot } from 'radium';
import * as superagent from 'superagent';
import * as Tgcc from '../../tgccGlobal';
import * as Request from '../../tgccRequest';
import Tooltip from '../Tooltip';
import { Dispatch } from 'redux';
import ThankYouPopup from './ThankYouPopup';


const baseInputStyle: CSSProperties = {
    padding: '10px 15px',
    borderRadius: '4px',
    fontFamily: "trajan-color",
    marginBottom: '10px',
    border: '2px solid black', // Thicker, black border
    boxShadow: '5px 5px 0px rgba(0,0,0,0.75)', // Shadow for 3D effect
    color: 'white', // White text
    boxSizing: 'border-box', // Include padding in width calculation
    fontSize: '16px',
  };
  
  const inputStyle: CSSProperties = {
    ...baseInputStyle,
    backgroundColor: 'lightgray',
    color: '#333',
    '::placeholder': {
        color: '#ccc', // Lighter color for placeholder text
      },
    ':focus': {
      borderColor: '#5b9dd9',
      outline: 'none',
      boxShadow: '0 0 5px rgba(91, 157, 217, 0.5)', // Add a soft blue glow
    },
    '@media (max-width: 768px)': {
        padding: '8px',
    },
  };

  const buttonStyle: CSSProperties = {
    ...baseInputStyle,
    padding: '10px 20px',
    backgroundColor: '#6893CC', // Bright color
    color: '#fff',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    fontFamily: "trajan-color",
    cursor: 'pointer',
    border: '2px solid black',
    boxShadow: 'none',
    ':hover': {
      backgroundColor: '#0056b3',
    },
    ':focus': {
      boxShadow: '0 0 0 2px rgba(0, 123, 255, 0.5)',
    },
    '@media (max-width: 768px)': {
        padding: '12px 15px',
    },
  };

  // Popup overlay styles
const popupOverlayStyle: CSSProperties = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.7)', // Dim the background
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000, // Make sure it's above everything else
  };
  
  // Popup inner styles (the actual form container)
  const popupInnerStyle: CSSProperties = {
    padding: '20px',
    zIndex: 1000, // Make sure it's above everything else
    borderRadius: '10px',
    backgroundColor: '#2e2b2b', // Use a contrasting color for the form background
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Soft shadow for depth
    width: '90%', // Use a percentage width for responsiveness
    position: 'relative', // Add this line
    maxWidth: '500px', // Maximum width for larger screens
    boxSizing: 'border-box',
  };
  
  // Updated input style with better spacing and border
  const updatedInputStyle: CSSProperties = {
    ...inputStyle,
    margin: '10px 0', // Add spacing between inputs
    width: '100%' // Full width minus padding
  };
  
  // Updated button style with full width
  const updatedButtonStyle: CSSProperties = {
    ...buttonStyle,
    width: '100%', // Full width button
    margin: '10px 0', // Add some margin to the top
  };

  const popupHeaderStyle: CSSProperties = {
    color: 'white', // Or any color that fits your design
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: '24px', // Adjust the size as needed
    margin: '0 0 10px 0', // Some margin to the bottom
  };
  
  const popupSubheaderStyle: CSSProperties = {
    color: 'white', // Or any color that fits your design
    textAlign: 'center',
    fontSize: '18px', // Adjust the size as needed
    margin: '0 0 20px 0', // Some margin to the bottom
  };

  const closeButtonStyle: CSSProperties = {
    position: 'absolute',
    top: '10px',
    right: '10px',
    backgroundColor: 'transparent',
    border: 'none',
    color: 'white',
    cursor: 'pointer',
    fontSize: '20px',
    padding: '0', // Adjust padding as needed
    zIndex: 1100, // Ensure it's above other content
};


export interface TShirtHeroLoginPopupProps {
    isOpen: boolean;
    onClose: () => void;
    onLoginSuccess: () => void;
    attemptedEmail?: string;
    showThankYouPopup: (show: boolean, source: string) => void;
    dispatch: Dispatch<any>;

}

class _TShirtHeroLoginPopup extends React.Component<TShirtHeroLoginPopupProps, any> {
    _isMounted = false; // Property to keep track of mount status

    constructor(props: TShirtHeroLoginPopupProps) {
        super(props);
        this.state = {
            email: '',
            password: '',
            error: '',
            isLoading: false,
            address: {
                address1: '',
                address2: '',
                city: '',
                state: '',
                zip: '',
            },
            step: 1, // Step 1 for login, Step 2 for address confirmation
            showForgotPasswordPopup: false,

        };
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }


    componentDidUpdate(prevProps: TShirtHeroLoginPopupProps) {
        // When the popup is opened and there is an attemptedEmail passed, set it
        if (this.props.isOpen && !prevProps.isOpen && this.props.attemptedEmail) {
            this.setState({ email: this.props.attemptedEmail });
        }
    }
    
    handleLogin = (e) => {
        e.preventDefault();
        this.setState({ isWaiting: true });
        const { email, password } = this.state;
        
        Request.loginUser(email, password,
            (loginData) => {
                localStorage.setItem('loginData', JSON.stringify(loginData));
                Tgcc.successfulLogin(this.props.dispatch, loginData, false);
                this.setState({ isWaiting: false });

                Request.updateHeroLoginTimestamp(loginData, email, 
                    (response) => {
                        console.log("Timestamp response:", response);
                        this.fetchUserInfoAndProceed(loginData);
                    },
                    (err) => {
                        if (err && err.response && err.response.body) {
                            if (err.response.body.error === "User not found or timestamp already set") {
                                console.log("Timestamp already set. Proceeding with login.");
                            } else {
                                console.error("Error updating timestamp:", err.response.body.error);
                            }
                        } else {
                            console.error("Error updating timestamp: Unknown error");
                        }
                        this.fetchUserInfoAndProceed(loginData);
                    }
                );
            },
            (err) => {
                this.setState({ isWaiting: false });
                let errorMessage = "An error occurred during login";
                if (err && typeof err === 'string') {
                    errorMessage = err;
                }
                this.setState({ error: errorMessage });
            }
        )
        };
    
    
    fetchUserInfoAndProceed = (loginData) => {
        // Fetch user's address info and proceed with step 2
        Request.getUserInfo(loginData, (userInfo) => {
            this.setState({
                step: 2,
                address: {
                    address1: userInfo.address,
                    address2: userInfo.address2,
                    city: userInfo.city,
                    state: userInfo.state,
                    zip: userInfo.zip
                }
            });
            this.props.onLoginSuccess();
        });
    };

    handleAddressConfirmation  = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const { address } = this.state;
        const loginData = JSON.parse(localStorage.getItem('loginData'));
        this.setState({ isWaiting: true });

        
        if (loginData) {
            Request.updateUserAddress(loginData, address, 
                (data) => {
                    if (this._isMounted) {
                        this.setState({ isWaiting: false });
                        this.props.onClose();
                        this.props.showThankYouPopup(true, 'login');
                    }
                },
                (err) => {
                    if (this._isMounted) {
                        this.setState({ isWaiting: false });
                        this.setState({ error: "Failed to update address. Please try again." });
                    }
                }
            );
        } else {
            if (this._isMounted) {
                this.setState({ isWaiting: false });
                this.setState({ error: "Unable to authenticate. Please log in again." });
            }
        }
    };
    
    handleInputChange = (event: React.FormEvent<HTMLInputElement | HTMLSelectElement>) => {
        const target = event.target as HTMLInputElement | HTMLSelectElement;
        const { name, value } = target;
        if (this.state.step === 1) {
            // Handle changes for the login form
            this.setState({
                [name]: value
            });
        } else {
            // Handle changes for the address form
            this.setState({
                address: {
                    ...this.state.address,
                    [name]: value
                }
            });
        }
    };

    // Method to handle the 'Forgot Password' button click
    forgotPassword = () => {
        this.props.onClose();
        this.setState({ showForgotPasswordPopup: true });
        this.props.dispatch({
            type: Tgcc.StateAction.DialogAction, 
            payload: { 
                action: Tgcc.DialogAction.ForgotPassword, 
                payload: { email: this.state.email }
            }
        });
    };
    
    // Method to close the forgot password modal
closeForgotPasswordPopup = () => {
    this.setState({ showForgotPasswordPopup: false });
};


    renderLoginForm = () => {
        return (
            <div>
                <h2 style={popupHeaderStyle}>Welcome Back, Hero!</h2>
                <p style={popupSubheaderStyle}>
                    Log in to continue your journey and learn more about winning $1000 in Group Apparel!
                </p>

                {this.state.error && <div style={{ color: 'red' }}>{this.state.error}</div>}
                <form onSubmit={this.handleLogin} style={{ width: '100%' }}>
                        <input
                        type="email"
                        name="email"
                        placeholder="Email"
                        key="email"
                        autoComplete='username'
                        style={updatedInputStyle}
                        value={this.state.email}
                        onChange={this.handleInputChange}
                        />
                        <input
                        type="password"
                        name="password"
                        placeholder="Password"
                        key="password"
                        autoComplete='current-password'
                        style={updatedInputStyle}
                        value={this.state.password}
                        onChange={this.handleInputChange}
                        />
                    {this.state.isWaiting ? <Tgcc.LoadingElement /> : <button style={updatedButtonStyle} type="submit">Login</button>}

                </form>
                    <div onClick={this.forgotPassword} style={{ cursor: 'pointer', color: 'white', marginTop: '10px', zIndex: 1100}}>
                        Forgot password?
                    </div>
            </div>
        );
    };
      
    renderAddressForm = () => {
        const { address1, address2, city, state, zip } = this.state.address;
        return (
          <div>
            <h2 style={popupHeaderStyle}>Confirm Your Details</h2>
            <p style={popupSubheaderStyle}>
                Make sure your current mailing address is accurate
            </p>

            <form onSubmit={this.handleAddressConfirmation} style={{ width: '100%' }}>
              <input
                type="text"
                name="address1"
                key="address1"
                placeholder="Address 1"
                value={address1}
                style={updatedInputStyle}
                onChange={this.handleInputChange}
              />
              <input
                type="text"
                name="address2"
                key="address2"
                placeholder="Address 2"
                value={address2}
                style={updatedInputStyle}
                onChange={this.handleInputChange}
              />
              <input
                type="text"
                name="city"
                key="city"
                placeholder="City"
                value={city}
                style={updatedInputStyle}
                onChange={this.handleInputChange}
              />
              <input
                type="text"
                name="state"
                key="state"
                placeholder="State"
                value={state}
                style={updatedInputStyle}
                onChange={this.handleInputChange}
              />
              <input
                type="text"
                name="zip"
                key="zip"
                placeholder="Zip Code"
                value={zip}
                style={updatedInputStyle}
                onChange={this.handleInputChange}
              />
            {this.state.isWaiting ? <Tgcc.LoadingElement /> : <button style={updatedButtonStyle} type="submit">Login</button>}
            </form>
          </div>
        );
      };

      render() {
        if (!this.props.isOpen) return null;
        const { error } = this.state;
    
        return (
            <div style={popupOverlayStyle}>
                <div style={popupInnerStyle}>
                    {/* Close Button */}
                <button onClick={this.props.onClose} style={closeButtonStyle}>
                    &#10005; {/* This is a simple 'X' symbol */}
                </button>


                    {this.state.step === 1 ? this.renderLoginForm() : this.renderAddressForm()}
                </div>

            </div>
        );
    }
}

const mapStateToProps = (state : Tgcc.GlobalState, ownState: any) => {
    return { state: state };
};

const mapDispatchToProps = (dispatch) => {
    return { dispatch };
};


export var TShirtHeroLoginPopup = connect(mapStateToProps, mapDispatchToProps)(_TShirtHeroLoginPopup);
